import React from "react"
import { Button } from "react-bootstrap"
import { WithT } from "i18next"
import { testId as commonTestIds } from "../../utility/tests/testId/common"
import styles from "./ImageUploadInput.module.scss"

const tNamespace = "common:image."

interface Props extends WithT {
    disabled: boolean
    onClick: () => void
    testId?: string
}

const UploadButton: React.FC<Props> = props => {
    const { disabled, onClick, t, testId = commonTestIds.selectFile } = props

    return (
        <Button
            disabled={disabled}
            variant="light"
            className={styles.imageUploadInput__btn}
            onClick={onClick}
            data-testid={testId}
        >
            {t(`${tNamespace}select-file`)}
        </Button>
    )
}

export default UploadButton
